<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div>
        <span style="font-size: 13px; color:#97a8be">首页 / 财务管理 / 财务流水</span>
      </div>
    </div>
    <div style="overflow:hidden; padding:15px 15px; padding-top: 0; line-height: 43px ">
      <span class="leftTd">财务名称</span>
      <input class="boxText" v-model="title" style="width: 200px; margin-left: 10px; margin-right: 10px;">
      <span class="leftTd">用户ID</span>
      <input class="boxText" v-model="code" style="width: 200px; margin-left: 10px; margin-right: 10px;">
      <span class="leftTd">手机号码</span>
      <input class="boxText" v-model="phone" style="width: 200px; margin-left: 10px;">
      <input @click="selectAdminList" type="button" style="cursor: pointer; padding: 7px 25px; border-radius: 3px; margin-left: 10px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="搜索" />
    </div>
    <!--    <div style="overflow:hidden; padding:0 15px;">-->
    <!--      <div @click="addAdmin" class="addBtn">+ 添加文章</div>-->
    <!--    </div>-->
    <div style="padding: 10px 15px">
      <div>
        <table width="100%">
          <tr>
            <th class="th">
              财务ID
            </th>
            <th class="th">
              财务名称
            </th>
            <th class="th">
              数目
            </th>
            <th class="th">
              变化前
            </th>
            <th class="th">
              备注
            </th>
            <th class="th">
              用户ID
            </th>
            <th class="th">
              昵称
            </th>
            <th class="th">
              手机号码
            </th>
            <th class="th">
              财务时间
            </th>
          </tr>
          <tr :key="index" v-for="(value,index) in adminList">
            <td class="td">
              {{ value.finId }}
            </td>
            <td class="td">
              {{ value.finName }}
            </td>
            <td class="td">
              {{ value.finAmount }}
            </td>
            <td class="td">
              {{ value.finOldAmount }}
            </td>
            <td class="td">
              {{ value.finNote }}
            </td>
            <td class="td">
              {{value.finUserId}}
            </td>
            <td class="td">
              {{ value.finUserName }}
            </td>
            <td class="td">
              {{ value.finUserPhone }}
            </td>
            <td class="td">
              {{ value.finTime }}
            </td>
          </tr>
        </table>
      </div>
      <div style="padding-top: 20px; font-size: 12px; color: #606266; text-align: right">
        一页显示 <input v-model="num" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/>
        条，共<span v-html="count"></span>条数据
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shouye.png" v-on:click="currPage(1)" title="首页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shangyiye.png" v-on:click="currPage(2)" title="上一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <input v-model="page" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/> / <span
          v-html="countPage"></span>页
        <img src="@/assets/home/xiayiye.png" v-on:click="currPage(3)" title="下一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/weiye.png" v-on:click="currPage(5)" title="尾页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
      </div>
    </div>
  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost} from "@/main";

export default {
  name: "FinanceList",
  data(){
    return{
      code:"",
      title:"",
      phone:"",
      type:"",
      user:"",
      adminList:[],
      page:1,
      num:10,
      count:0,
      countPage:0,
      imgUrl:"",
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    this.selectAdminList()
  },
  methods: {
    updateAdmin(obj){
      localStorage.setItem("UPDATEOBJ",JSON.stringify(obj))
      this.$emit("send",'updateNews')
    },
    auditAdmin(id){
      if(confirm("确认审核此申请吗？")){
        let that=this
        loading("加载中")
        axiosPost(DO_NET_URL+"filePhoto/AuditFilePhoto?id="+id,"",function (res){
          console.log(res.data)
          closeLoading()
          if(res.code==200){
            toask("审核成功！",6)
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    deleteAdmin(id){
      if(confirm("确认删除此申请吗？")){
        let that=this
        loading("加载中")
        axiosPost(DO_NET_URL+"filePhoto/DeleteFilePhoto?id="+id,"",function (res){
          console.log(res.data)
          closeLoading()
          if(res.code==200){
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    addAdmin(){
      this.$emit("send",'addNews')
    },
    currPage(num){
      if(num==1){
        this.page=1
      }else if(num==5){
        this.page=this.countPage
      }else if(num==2){
        if(this.page>1){
          this.page-=1
        }
      }else{
        if(this.page<this.countPage){
          this.page+=1
        }
      }
      this.selectAdminList()
    },
    async selectAdminList(){
      let that=this
      loading("加载中")
      axiosGet(DO_NET_URL+"finance/SelectFinance?id="+this.code+"&name="+this.title+"&phone="+this.phone+"&page="+this.page+"&num="+this.num,function (res){
        console.log(res.data)
        closeLoading()
        // that.imgUrl=res.data.imgUrl
        that.adminList=res.data.list
        that.count=res.data.num
        let page=parseInt(res.data.num/that.num)
        if(res.data.num%that.num>0){
          page+=1
        }
        that.countPage=page
        // localStorage.setItem("imgUrl",res.data.imgUrl)
      })
    },
  }
}
</script>

<style scoped>
.text1{
  border: 1px solid #dcdfe6;
  font-size: 12px;
  border-radius: 2px;
  outline: none;
  padding: 3px 10px;
}
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 35px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700;}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0px 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>